import { render, staticRenderFns } from "./ScaleLoader.vue?vue&type=template&id=055c6bf4"
import script from "./ScaleLoader.vue?vue&type=script&lang=js"
export * from "./ScaleLoader.vue?vue&type=script&lang=js"
import style0 from "./ScaleLoader.vue?vue&type=style&index=0&id=055c6bf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports